export function getSynonymFromRecord(
  synonyms: Record<string, string> | undefined,
  fallback: string,
  locale?: string | null,
  defaultLocale?: string,
): string {
  if (!synonyms) return fallback
  if (locale) {
    for (const key of [locale, defaultLocale]) {
      if (!key) continue
      const v = synonyms[key]
      if (v) return v
    }
  }
  return fallback
}

export function getObjectSynonym(
  obj: { synonyms?: Record<string, string>; name?: string } | null | undefined,
  fallback = '',
  locale?: string | null,
  defaultLocale?: string,
): string {
  if (!obj) return fallback
  return getSynonymFromRecord(obj.synonyms, obj.name ?? fallback, locale, defaultLocale)
}
